export const CURRENCY = new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: "MXN",
    maximumFractionDigits: 0,
});

export const formatPrice = (n) => CURRENCY.format(n || 0);

export const UNITS_LABEL = {
    kg: "kg", ton: "ton", cabeza: "cabeza", paca: "paca",
    hectarea: "hectárea", litro: "litro", pieza: "pieza",
    caja: "caja", costal: "costal",
};

export const ROLE_LABEL = {
    productor: "Productor",
    comprador: "Comprador",
    exportador: "Exportador",
    transportista: "Transportista",
    proveedor: "Proveedor Agrícola",
    admin: "Administrador",
};

export const getUserFirstName = (user) => {
    const identity = [user?.name, user?.email].find(
        (value) => typeof value === "string" && value.trim()
    );
    return identity ? identity.trim().split(/\s+/)[0] : "";
};

export const CATEGORY_ICON = {
    ganaderia: "Cow",
    frutas: "Apple",
    verduras: "Carrot",
    granos: "Grains",
    forrajes: "Plant",
    suministros: "Tractor",
};

export const waLink = (phone, text) => {
    const clean = (phone || "").replace(/\D/g, "");
    const number = clean.startsWith("52") ? clean : `52${clean}`;
    return `https://wa.me/${number}?text=${encodeURIComponent(text || "")}`;
};
